import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { initializeFileTypeIcons } from '@uifabric/file-type-icons';
import { initializeIcons } from "@fluentui/react";
import { registerIcons } from '@uifabric/styling';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';

import configureStore from './store/configureStore';
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./index.css";

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0]?.getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

initializeFileTypeIcons();
initializeIcons();

registerIcons({
  icons: {
    Barcode: <FontAwesomeIcon icon={faBarcode} />
  }
});

ReactDOM.render(
  <>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </>,
  document.getElementById("root")
);
